import {
  LABORDENDIGITAL_GETPDF_ERROR,
  LABORDENDIGITAL_GETPDF_LOADING,
  LABORDENDIGITAL_GETPDF_RESET,
  LABORDENDIGITAL_GETPDF_SUCCESS,
} from "_+_Portal/context/ActionTypes";
import axiosInstance from "global/helpers/axiosInstance";

export const wsGetPDFOrdenDigital = (idPacFamiliar, nextStep) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_GETPDF_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/LabOrdenDigital/GetPDF/${idPacFamiliar}`)
      .then((res) => {
        dispatch({
          type: LABORDENDIGITAL_GETPDF_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABORDENDIGITAL_GETPDF_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const resetPDFOrdenDigital = () => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_GETPDF_RESET,
  });
};
